import { gql } from '@apollo/client';

export const CREATE_SURROUNDING_INFORMATION_CATEGORY_LOCALIZATION_MUTATION = gql`
  mutation CreateSurroundingInformationCategoryLocalization(
    $data: updateSurroundingInformationCategoryInput!
  ) {
    createSurroundingInformationCategoryLocalization(input: $data) {
      id
    }
  }
`;
